import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CarrierType, ShipmentType } from "entities/shared/shipmentCard.types";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { ValueOf } from "shared/lib/typeCheck.lib";

type SearchFilter = {
  searchReference: string;
  shipment: ValueOf<typeof ShipmentType>;
  isShipmentTypeConfirmed: boolean;
  carrier: CarrierType | null;
  allowedShipmentTypes: ValueOf<typeof ShipmentType>[];
};

const initialSearchFilter: SearchFilter = {
  searchReference: "",
  shipment: ShipmentType.SEA,
  isShipmentTypeConfirmed: false,
  carrier: null,
  allowedShipmentTypes: [],
};

const searchFilterSlice = createSlice({
  name: "searchFilter",
  initialState: initialSearchFilter,
  reducers: {
    setSearchReference: (state, action: PayloadAction<string>) => {
      state.searchReference = action.payload;
    },
    setShippingType: (state, action: PayloadAction<ValueOf<typeof ShipmentType>>) => {
      state.shipment = action.payload;
      state.isShipmentTypeConfirmed = true;
    },
    setCarrier: (state, action: PayloadAction<CarrierType | null>) => {
      state.carrier = action.payload;
    },
    setAllowedShipmentTypes: (state, action: PayloadAction<ValueOf<typeof ShipmentType>[]>) => {
      state.allowedShipmentTypes = action.payload;
    },
  },
});

const appBaseSelector = createBaseSelector(searchFilterSlice);

registerSlice([searchFilterSlice]);

export const searchFilterStore = {
  actions: searchFilterSlice.actions,
  selectors: {
    searchReference: createSelector(appBaseSelector, (s) => s.searchReference),
    shipment: createSelector(appBaseSelector, (s) => s.shipment),
    isShipmentTypeConfirmed: createSelector(appBaseSelector, (s) => s.isShipmentTypeConfirmed),
    carrier: createSelector(appBaseSelector, (s) => s.carrier),
    allowedShipmentTypes: createSelector(appBaseSelector, (s) => s.allowedShipmentTypes),
    isGlobalTracking: createSelector(appBaseSelector, (s) => s.allowedShipmentTypes.length > 1),
  },
};
